module.exports = __webpack_public_path__ + "img/cirros.446d48a8.png";